import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DescriptiveEventTableComponent } from './descriptive-event-table.component'
import { SharedModule } from '../shared/shared.module'
import { PipesModule } from '../../pipes/pipes.module'
import { RouterModule } from '@angular/router'



@NgModule({
  declarations: [DescriptiveEventTableComponent],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,
    RouterModule,
  ],
  exports: [DescriptiveEventTableComponent]
})
export class DescriptiveEventTableModule { }
